import React from "react";
import { Heart } from "lucide-react";

/**
 * Inline SVG / styled brand wordmarks for the wearables bar.
 * These are visual approximations only.
 */

export const AppleHealthMark = () => (
  <div className="flex items-center gap-2">
    <Heart className="h-7 w-7 fill-[#FF2D55] text-[#FF2D55]" strokeWidth={0} />
    <span className="leading-tight text-slate-700">
      <span className="block text-base font-semibold">Apple</span>
      <span className="block text-base font-semibold -mt-1">Health</span>
    </span>
  </div>
);

export const OuraMark = () => (
  <span className="text-2xl font-light tracking-[0.18em] text-slate-800">
    Ō<span className="font-normal">URA</span>
  </span>
);

export const WhoopMark = () => (
  <div className="flex items-center gap-2 text-slate-800">
    <span className="grid h-6 w-6 place-items-center rounded-full border-2 border-slate-800 text-[10px] font-bold">
      W
    </span>
    <span className="text-xl font-semibold tracking-[0.18em]">WHOOP</span>
  </div>
);

export const FitbitMark = () => (
  <div className="flex items-center gap-2 text-slate-800">
    <span className="flex gap-0.5">
      <span className="block h-2 w-2 rounded-full bg-slate-800" />
      <span className="block h-3 w-2 rounded-full bg-slate-800" />
      <span className="block h-4 w-2 rounded-full bg-slate-800" />
    </span>
    <span className="text-2xl font-light italic tracking-tight">fitbit</span>
  </div>
);

export const GarminMark = () => (
  <span className="relative text-2xl font-semibold tracking-[0.18em] text-slate-800">
    GARMIN
    <span className="absolute -top-2 right-0 text-xs">▲</span>
  </span>
);

export const DexcomMark = () => (
  <span className="text-2xl font-bold tracking-tight text-slate-800">dexcom</span>
);

export const WithingsMark = () => (
  <span className="text-xl font-semibold tracking-[0.32em] text-slate-800">WITHINGS</span>
);
